// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"49b12272","768":"65afd828","791":"71ece0aa"}[chunkId] + ".chunk.js";
};